import React from 'react';
import { useTranslation } from 'react-i18next';
import StripAction from '../../../../../components/StripAction';
import { CHOOSE_METHOD_TYPES, TITLE_TYPE_MAP } from '../consts';
import { IPaymentMethods } from '../hooks/useFetchInitialData';
import { ReactComponent as BankMethodIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-bank.svg';
import { ReactComponent as CheckMethodIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-mail.svg';
import { ReactComponent as WireMethodIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-wire.svg';
import { ReactComponent as InternationalWireMethodIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-international-wire.svg';
import { ReactComponent as AskVendorMethodIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-envelope-email.svg';
import Heading from '../../../../../generic-components/Heading';
import TitleBadge from '../../../../../components/TitleBadge';
import { PaymentMethods } from '../../../types';

const ICON_TYPE_MAP = {
  ACH: <BankMethodIcon />,
  CHECK: <CheckMethodIcon />,
  WIRE: <WireMethodIcon />,
  ASK_VENDOR: <AskVendorMethodIcon />,
  INTERNATIONAL_WIRE: <InternationalWireMethodIcon />,
};

interface IProps {
    onStripClick: (type: string) => void;
    paymentMethods?: IPaymentMethods;
    isShowAskVendorDetails?: boolean;
}

const StripActionList = ({ onStripClick, paymentMethods, isShowAskVendorDetails } : IProps) => {
  const { t } = useTranslation();
  const validMethods = paymentMethods?.methods.filter(method => method.status === 'VALID');
  const invalidMethods = paymentMethods?.methods.filter(method => method.status !== 'VALID');
  return (
    <div className='w-[480px] max-w-[480px] flex flex-col gap-[16px]'>
      {!!validMethods?.length && validMethods?.map(({
        methodType, expectedArrival,
      }) => (
        <StripAction
          key={methodType}
          title={TITLE_TYPE_MAP[methodType as keyof typeof TitleBadge]}
          actionType={methodType}
          onActionClick={(actionType) => onStripClick(actionType)}
          icon={ICON_TYPE_MAP[methodType as keyof typeof ICON_TYPE_MAP]}
          subTitle={expectedArrival}
          badge={methodType === paymentMethods?.lastUsed ? <TitleBadge title='Last Used' colorSchemeId='LAST_USED' /> : ''}
        />

      ))}
      {!!invalidMethods?.length && (
        <div className='border-t-[1px] border-bw03 pt-[24px]'>
            {invalidMethods?.map(({
              methodType, expectedArrival, statusReason,
            }) => (
              <div className='flex flex-col'>
                <StripAction
                  key={methodType}
                  disabled
                  title={TITLE_TYPE_MAP[methodType as keyof typeof TitleBadge]}
                  actionType={methodType}
                  onActionClick={(actionType) => onStripClick(actionType)}
                  icon={ICON_TYPE_MAP[methodType as keyof typeof ICON_TYPE_MAP]}
                  subTitle={expectedArrival}
                />
                {statusReason && <Heading title={statusReason} className='font-metricR text-bw06 text-[14px] mt-[10px] text-left' />}
              </div>
            ))}
        </div>
      )}
      {isShowAskVendorDetails && (
      <>
        <div className='relative flex items-center my-4'>
          <div className='flex-grow border-t border-bw03' />
          <span className='mx-4 font-metricR text-[14px] text-bw06'>Or</span>
          <div className='flex-grow border-t border-bw03' />
        </div>
        <StripAction
          key='vendor'
          title={t('ASK_YOUR_VENDOR.PAYMENT_METHOD_TITLE')}
          actionType={CHOOSE_METHOD_TYPES.ASK_VENDOR}
          onActionClick={(actionType) => onStripClick(actionType)}
          icon={ICON_TYPE_MAP[PaymentMethods.ASK_VENDOR as keyof typeof ICON_TYPE_MAP]}
          subTitle={t('ASK_YOUR_VENDOR.PAYMENT_METHOD_SUBTITLE')}
        />
      </>
      )}
    </div>
  );
};

export default StripActionList;
